export default {"src":"/_next/static/media/pl.a35c7c75.svg","height":10,"width":16};